module.exports = __webpack_public_path__ + "static/scrape-any-website-f8f670c61629d1eee53f80449931ec1a.png";